export default "__VITE_ASSET__BckYuUqu__"